import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import { useCommunitySwitcherContext } from "../context/CommunitySwitcherContext";
import { cn } from "../helpers/cn";

export interface CommunitiesModalLinkStaticDragControlProps {
  readonly isDragDisabled: boolean;
}

export const CommunitiesModalLinkStaticDragControl = ({
  isDragDisabled,
}: CommunitiesModalLinkStaticDragControlProps) => {
  const { t } = useCommunitySwitcherContext();

  return (
    <span className="inline-flex shrink-0">
      <Tooltip
        content={t("community_switcher_drag_handle")}
        delay={200}
        side="top"
      >
        <IconButton
          aria-label={t("community_switcher_drag_handle")}
          className={cn({
            "cursor-grab": !isDragDisabled,
            "cursor-not-allowed": isDragDisabled,
          })}
          disabled={isDragDisabled}
          icon="drag"
          size="sm"
          variant="ghost"
        />
      </Tooltip>
    </span>
  );
};
